export const SET_ALL = 'SET_ALL';
export const UPDATE_FARM_DATA = 'UPDATE_FARM_DATA';
export const RESET_FARM_DATA = 'RESET_FARM_DATA';
export const SET_DOCUMENT_AS_READ = 'SET_DOCUMENT_AS_READ';
export const SET_FINANCIAL_STATEMENTS_DOCUMENT_AS_READ = 'SET_FINANCIAL_STATEMENTS_DOCUMENT_AS_READ';
